<template lang="html">
  <v-container class='fluid'>
    <v-layout align-center justify-center>
      <v-flex xs10>
        <v-card class="text-xs-center">
          <basic-toolbar :title="'Editar Localidade'"></basic-toolbar>
          <v-card-text>
            <v-form v-model="formularioValido" ref="form">
              <v-container>

                <v-layout row wrap justify-space-between>
                  <v-flex xs12>
                    <v-text-field
                      label='Nome da localidade ou instituição'
                      v-model="localidade.nome"
                      required
                      :rules="regrasBasicas"
                      max-height="400">
                    </v-text-field>
                  </v-flex>
                </v-layout>

                <v-layout row wrap justify-space-between>
                  <v-flex xs11 sm5>
                    <v-select
                      label='Estado'
                      :items="listaEstados"
                      @change="atualizaCidades($event)"
                      v-model="localidade.ufCidade"
                      item-text="descricao"
                      item-value="item"
                      prepend-icon="dashboard"
                      max-height="400"
                      return-object
                      required
                      autocomplete
                      :rules="regrasBasicas" >
                    </v-select>
                  </v-flex>

                  <v-flex xs11 sm5>
                    <v-select
                      label='Município'
                      :items="listaCidades"
                      v-model="localidade.cidade"
                      item-text="nomeCidade"
                      item-value="id"
                      prepend-icon="dashboard"
                      max-height="400"
                      return-object
                      autocomplete
                      :rules="regrasBasicas" >
                    </v-select>
                  </v-flex>
                </v-layout>

                <v-layout row wrap justify-space-between>
                  <v-flex xs12>
                    <v-text-field
                      label='CEP'
                      v-if='listaCidadesSelecionadas.length < 2'
                      v-model="localidade.cep"
                      max-height="400">
                    </v-text-field>
                  </v-flex>
                </v-layout>

                <v-layout row wrap justify-space-between>
                  <v-flex xs12>
                    <c-textarea
                      label="Informações adicionais"
                      v-model="localidade.detalhes"
                      :rows="3"
                      :auto-grow="true"
                      multi-line
                      counter="200"
                     >
                    </c-textarea>
                  </v-flex>
                </v-layout>

              </v-container>
            </v-form>
            <v-divider></v-divider>
            <v-card-actions>
              <v-btn color="primary" text @click="cancelar">Cancelar</v-btn>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="editarLocalidade()" :disabled="!formularioValido">Salvar</v-btn>
            </v-card-actions>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import BasicToolbar from '@/components/toolbars/basic-toolbar'
  import ToolTip from '@/components/app-layouts/app-tooltip/tooltip'
  import DataMenu from '@/components/c-date-menu'
  import TextArea from '@/components/c-textarea'
  import CheckboxTable from '@/components/c-checkbox-table'
  import projetos from '@/utils/projetos'
  import { mapActions } from 'vuex'

  export default {
    props: ['idProjeto', 'idLocalidade'],
    data: () => ({
      search: null,
      headers: [
        { checkbox: true, sortable: false },
        { text: 'Nome', align: 'center', value: 'nomeCidade' }
      ],
      sortDesc: false,
      itemsPerPage: 5,
      opcoesPaginacao: [ 5, 10, 25, 50, {text: 'Todas', value: -1} ],
      formularioValido: false,
      localidade: {
        nome: '',
        detalhamento: '',
        ufCidade: {}
      },
      contador: 0,
      projeto: {
        titulo: '',
        dataInicio: '',
        dataConclusao: '',
        observacoes: '',
        situacao: {},
        tipoPublico: {},
        tipoEvento: {}
      },
      listaEstados: [],
      listaCidades: [],
      listaCidadesSelecionadas: [],
      regrasBasicas: [
        (input) => !!input || 'Este campo é obrigatório'
      ],
      assuntoSummaryRules: [
        (input) => !!input || 'Este campo é obrigatório',
        (input) => !!input && input.length <= 200 || 'Este campo não pode possuir mais que 200 caracteres'
      ]
    }),
    methods: {
      ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']),
      cancelar: function () {
        this.$router.push({name: 'AbrangenciaProjeto', params: {idProjeto: this.idProjeto}})
      },
      editarLocalidade: function () {
        projetos.putLocalidade(this.idProjeto, this.idLocalidade, this.localidade)
        .then(response => {
          this.SHOW_SNACKBAR({snackbarType: 'success', snackbarText: response.body.mensagem})
          this.$router.push({name: 'AbrangenciaProjeto', params: {idProjeto: this.idProjeto}})
        })
        .catch(error => {
          this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: error.body.mensagem})
        })
        .finally(() => {
        })
      },
      atualizaCidades: function (event) {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando cidades.' })
        projetos.getCidades(event.item)
        .then(response => {
          this.listaCidades = response.data.slice()
        })
        .catch(error => {
          console.log('Erro ao mandar o request' + error)
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando cidades.' })
        })
      },
      atualizaListaCidadesSelecionadas: function (cidade) {
        console.log(this.listaCidadesSelecionadas)
      },
      opcoesTabelaEstruturada: function (codTabela, aqui, atributo) {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando opções.' })
        projetos.getOpcoesTabelaEstruturada(codTabela)
        .then(response => {
          aqui[atributo] = response.data.slice()
        })
        .catch(error => {
          console.log('Erro ao mandar o request' + error)
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando opções.' })
        })
      }
    },
    mounted () {
      console.log(this.idLocalidade)

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' })
      projetos.getProjeto(this.idProjeto)
      .then(response => {
        this.projeto = response.data
        this.dataInicioFormatada = this.dates.format(this.projeto.dataInicio)
        this.dataConclusaoFormatada = this.dates.format(this.projeto.dataConclusao)
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' })
      })

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando estados.' })
      projetos.getEstados(1)
      .then(response => {
        this.listaEstados = response.data
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando estados.' })
      })

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando localidade.' })
      projetos.getLocalidade(this.idProjeto, this.idLocalidade)
      .then(response => {
        this.localidade = response.data

        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando estado.' })
        projetos.getCidades(this.localidade.ufCidade.item)
        .then(response => {
          this.listaCidades = response.data.slice()
        })
        .catch(error => {
          console.log('Erro ao mandar o request' + error)
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando estado.' })
        })
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando localidade.' })
      })
    },
    components: {
      'basic-toolbar': BasicToolbar,
      'tooltip': ToolTip,
      'c-date-menu': DataMenu,
      'c-checkbox-table': CheckboxTable,
      'c-textarea': TextArea
    }
  }
</script>

<style lang="css">
  .menu {
    display: block !important;
  }

  .no-resize div textarea{
    resize: none;
  }
  .input-group__icon-cb {
    cursor: pointer !important;
  }
</style>



// WEBPACK FOOTER //
// editar-localidade.vue?059491bc